<template>
  <div class="cd-rw">
    <report-state v-if="loading" kind="loading"></report-state>
    <report-state v-else-if="failed" kind="error" @retry="load"></report-state>
    <report-state
      v-else-if="!workers.length"
      icon="mdi-account-off-outline"
      :title="$t('no_employees_found')"
      :text="$t('no_employees_ordered_this_meal')"
    ></report-state>

    <ul v-else class="ui-card rd-card cd-rw__list">
      <li v-for="worker in workers" :key="worker.id" class="cd-rw__row">
        <span class="ui-avatar ui-avatar--neutral">{{ worker.initials }}</span>
        <span class="cd-rw__text">
          <span class="cd-rw__name">{{ worker.name }}</span>
          <span class="rd-muted rd-num cd-rw__meta">{{ worker.meta }}</span>
        </span>
        <span class="cd-rw__shifts">
          <span v-for="shift in worker.shifts" :key="shift.id" class="cd-rw__shift rd-num">
            <report-shift-tag :shift="shift.id"></report-shift-tag>
            {{ shift.quantity }}
          </span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import reportService from "@/services/report";
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";
import ReportState from "@/components/report/desktop/ReportState.vue";
import { groupReservedWorkers } from "../../reservedWorkers";

/**
 * Panel "Radnici koji su naručili obrok" (iz Rezervnih obroka): radnici izabranog obroka po smenama. Podatke
 * (spisak narudžbi izabranih firmi za period) učitava sam.
 */
export default {
  name: "CompanyDesktopReservedWorkers",
  components: { ReportShiftTag, ReportState },
  props: {
    meal: { type: Object, default: null },
    /** id-jevi izabranih firmi */
    companyIds: { type: Array, default: () => [] },
    from: { type: String, default: "" },
    to: { type: String, default: "" },
  },
  data: () => ({
    data: null,
    loading: false,
    failed: false,
    requestId: 0,
  }),
  computed: {
    workers() {
      return groupReservedWorkers(this.data, this.meal, this.toLatin);
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.companyIds.length) {
        return;
      }
      const requestId = ++this.requestId;
      this.loading = true;
      this.failed = false;
      try {
        const response = await reportService.getCompanyUserList(this.companyIds.join(","), {
          date: this.from,
          date2: this.to,
        });
        if (requestId === this.requestId) {
          this.data = response.data;
        }
      } catch (error) {
        if (requestId === this.requestId) {
          this.failed = true;
        }
      } finally {
        if (requestId === this.requestId) {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.cd-rw {
  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    border-bottom: 1px solid var(--rm-divider-soft);

    &:last-child {
      border-bottom: none;
    }
  }

  &__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  &__meta {
    font-size: 12px;
    overflow-wrap: anywhere;
  }

  &__shifts {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4px 12px;
  }

  &__shift {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
  }
}
</style>
